<template>
  <page-status class="insure-qrcode" :loading="loading">
    <div class="insure-qrcode-issue">
      <div class="issue-background">
        <img src="@/assets/img-issue-bg.png" />
      </div>
      <div class="issue-content">
        <div class="issue-content-header">
          <img class="icon" src="@/assets/img-issue-qrcode.png" />
          <div class="tip">扫码支付</div>
          <div class="amount" v-if="payment.code !== 'CREDITPAY'">
            {{ payInfo.totalAmount }}元
          </div>
          <qrcode-vue
            :value="payInfo.qrCodeStr"
            size="150"
            level="H"
          ></qrcode-vue>
        </div>
        <div class="issue-content-main">
          <div class="row">
            <span class="label">车牌号：</span>
            <span class="value">{{ payInfo.plateNo || '新车未上牌' }}</span>
          </div>
          <div class="row">
            <span class="label">车架号：</span>
            <span class="value">{{ payInfo.frameNo }}</span>
          </div>
          <div class="row">
            <span class="label">投保险人：</span>
            <span class="value">{{ payInfo.appliName }}</span>
          </div>
          <div class="row">
            <span class="label">总保费：</span>
            <span class="value">{{ payInfo.totalAmount }}元</span>
          </div>
        </div>
      </div>
      <div class="issue-footer">
        <span>请打开</span>
        <span class="pay-type">{{ payment.name }}</span>
        <span>使用扫一扫进行认证支付</span>
        <span class="help" @click="showDialog = true">操作帮助</span>
      </div>
    </div>

    <div class="footer">
      <page-footer />
    </div>

    <van-dialog
      class="help-dialog"
      v-model="showDialog"
      title="操作帮助"
      confirm-button-text="关闭"
    >
      <div class="help-content">
        <div class="help-title">支付步骤：</div>
        <div class="help-item">① 保存二维码至手机相册；</div>
        <div class="help-item">
          ② 打开微信/支付宝扫一扫，选择相册中的二维码图片进行扫码支付；
        </div>
        <div class="help-item">③ 支付完成后，请耐心等待电子保单出具；</div>
        <div class="help-title">支付失败解决办法：</div>
        <div class="help-item">① 请确保使用投保人本人的支付宝/微信操作；</div>
        <div class="help-item">② 请确保投保人支付宝/微信已完成实名认证；</div>
        <div class="help-title">如有其它疑问，请联系业务员或客服：</div>
        <div class="help-hotline">400-820-2288</div>
      </div>
    </van-dialog>
  </page-status>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import PageStatus from '@/components/PageStatus';
import PageFooter from '@/components/PageFooter';
import * as services from '@/services';
import * as utils from '@/utils';
import * as qs from 'qs';

export default {
  components: {
    QrcodeVue,
    PageStatus,
    PageFooter,
  },

  data() {
    return {
      loading: true,
      showDialog: false,
      businessNo: '',
      payment: {},
      poaCode: '',
      payInfo: {},
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { query } = this.$route;
      const {
        businessNo,
        mobile,
        payType,
        payName,
        poaCode,
        businessSource,
      } = query;

      services.getOrderInfo(businessNo, mobile, payType, poaCode).then(res => {
        if (res.head.returnCode === '1') {
          this.$router.replace({ path: '/insure-result', query });
        } else {
          const search = { businessSource };
          const url = res.data.qrCodeStr;
          const qrCodeStr = `${url}&businessSource=${businessSource}&mobile=${mobile}`;
          window.location.replace(qrCodeStr);
        }
        // else {
        //   this.payInfo = res.data;
        //   this.businessNo = businessNo;
        //   this.payment = { code: payType, name: payName };
        //   this.poaCode = poaCode;
        //   this.loading = false;
        // }
      });
    },

    checkEnv(payType) {
      const env = utils.getClientEnv();
      const isWechat = payType === 'WEIXINJSAPI' && env === 'wechat';
      const isAlipay =
        (payType === 'ALIPAYWAPNEW' || payType === 'CREDITPAY') &&
        env === 'alipay';
      return isWechat || isAlipay;
    },
  },
};
</script>

<style lang="less">
.insure-qrcode {
  display: flex;
  min-height: 100%;
  flex-direction: column;

  .insure-qrcode-issue {
    position: relative;
    width: 100%;
    max-width: 340px;
    min-height: 480px;
    margin: 50px auto 0;
  }

  .issue-background {
    text-align: center;

    img {
      width: 100%;
    }
  }

  .issue-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
  }

  .issue-content-header {
    padding-top: 36px;
    text-align: center;

    .icon {
      width: 50px;
    }

    .tip {
      margin-bottom: 8px;
      font-size: 12px;
      font-weight: bold;
      color: #4a4a4a;
    }

    .amount {
      margin-bottom: 8px;
      font-size: 30px;
      font-weight: bold;
      color: #f13837;
    }
  }

  .issue-content-main {
    padding: 12px;

    .row {
      display: flex;
      align-items: center;
      margin: 8px auto;
      width: 240px;
    }

    .label {
      font-size: 12px;
      color: #888;
    }

    .value {
      flex: 1;
      font-size: 12px;
      color: #4a4a4a;
      text-align: right;
    }
  }

  .issue-footer {
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 20px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    height: 40px;
    font-size: 12px;
    color: #888;
    border-top: 1px solid #e4e4e4;

    .pay-type {
      color: #4294f5;
    }

    .help {
      flex: 1;
      text-align: right;
      color: #4294f5;
    }
  }

  .help-dialog {
    .help-content {
      padding: 12px 24px;
      font-size: 12px;
      line-height: 20px;

      .help-title {
        color: #4a4a4a;
      }

      .help-item {
        color: #9b9b9b;
      }

      .help-hotline {
        color: #4294f5;
      }
    }
  }

  .footer {
    margin-top: auto;
  }
}
</style>
